<template>
  <div ref="recBox">
    <v-container
      v-if="isLoading"
      style="height: 200px"
      class="d-flex align-center justify-center"
    >
      <v-progress-circular
        indeterminate
        color="var(--v-primary-base)"
      ></v-progress-circular>
    </v-container>
    <div v-else>
      <v-container
        v-if="presentation == 'grid' && items.length > 0"
        class="grid"
      >
        <div v-if="boxTitle">
          <p class="boxTitle">{{ boxTitle }}</p>
        </div>
        <v-row>
          <v-col
            v-for="item in items"
            :key="item.id"
            cols="6"
            xl="3"
            lg="3"
            md="3"
            sm="6"
            xs="6"
          >
            <item-card
              :class="{ 'add-hidden': item.notBookable || hideAddButton() }"
              :id="item.id"
              :price="item.price"
              :title="item.title"
              :subtitle="item.subtitle"
              :type="item.type"
              :imageUrl="item.imageUrl[0]"
              :campaignValue="item.campaignValue"
              :campaignText="item.campaignText"
              :border="border()"
              :isAdded="item.isAdded"
              :isFavorite="item.isFavorite"
              @clickCard="redirect(item)"
              @clickButton="addToCard(item)"
              @logView="(item, action) => logUserActivity(item, action)"
              :logViews="true"
              :stockAmount="item.type == ItemType.P ? stockAmount(item.id) : 1"
              :showPrice="!priceHidden()"
              :overrideText="overrideBookingButton() ? overrideText : null"
            ></item-card>
          </v-col>
        </v-row>
        <v-row v-if="btnText">
          <v-col align="end">
            <p @click="clickMoreBtn">
              <span class="moreText">{{ btnText }}</span>
              <v-icon color="var(--v-primary-base)">fxt-chevron-right</v-icon>
            </p>
          </v-col>
        </v-row>
      </v-container>
      <v-container
        class="slide-group"
        v-if="presentation == 'carousel' && items.length > 0"
      >
        <div v-if="boxTitle">
          <p class="boxTitle" style="padding-bottom: 16px !important">
            {{ boxTitle }}
          </p>
        </div>
        <v-slide-group show-arrows>
          <template v-slot:next>
            <v-btn large outlined icon class="button">
              <v-icon>fxt-chevron-right-alt</v-icon></v-btn
            >
          </template>
          <template v-slot:prev>
            <v-btn large outlined icon class="button">
              <v-icon>fxt-chevron-left-alt</v-icon></v-btn
            >
          </template>
          <v-slide-item v-for="(item, index) in items" :key="index">
            <item-card
              :class="[
                item.type === ItemType.T ? 'tret' : 'prod',
                item.notBookable || hideAddButton() ? 'add-hidden' : '',
              ]"
              :id="item.id"
              :price="item.price"
              :title="item.title"
              :subtitle="item.subtitle"
              :imageUrl="item.imageUrl[0]"
              :type="item.type"
              :campaignValue="item.campaignValue"
              :campaignText="item.campaignText"
              :border="border()"
              :isAdded="item.isAdded"
              :isFavorite="item.isFavorite"
              @clickCard="redirect(item)"
              @clickButton="addToCard(item)"
              @logView="(item, action) => logUserActivity(item, action)"
              :logViews="true"
              :stockAmount="item.type == ItemType.P ? stockAmount(item.id) : 1"
              :showPrice="!priceHidden()"
              :overrideText="overrideBookingButton() ? overrideText : null"
            ></item-card>
          </v-slide-item>
        </v-slide-group>
        <v-row v-if="btnText" style="margin-top: 4px">
          <v-col align="end">
            <p @click="clickMoreBtn">
              <span class="moreText">{{ btnText }}</span>
              <v-icon color="var(--v-primary-base)">fxt-chevron-right</v-icon>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import ItemCard from '@fixit/v-b2c-item/src/B2CItemCard.vue';
import RecSvc from './services/rec-svc';
import { Channel, ItemType, Location, ActionType } from './enums';

let service = null;

export default {
  name: 'RecommendationBox',
  data() {
    return {
      ActionType,
      recItems: [],
      isLoading: false,
      ItemType,
    };
  },
  components: {
    ItemCard,
  },
  props: {
    userId: {
      type: Number, // OnlineSsluttKundeId
    },
    chainId: {
      type: Number, // ChainId of the salon/homepage the customer is in
    },
    siteIds: {
      type: Array, // SiteId of the salon the customer is in : can be empty
    },
    itemType: {
      type: String, // Type of items wanted: products, tretments
      validator(value) {
        return Object.values(ItemType).includes(value);
      },
    },
    channel: {
      type: String, // Type of platforms App, FixitNo, HomePage, Salondata, Nettbutik
      validator(value) {
        return Object.values(Channel).includes(value);
      },
    },
    location: {
      type: String, // Type od location HomePage, ProductPage, Cart, TreatmentPage, WebshopFrontPage
      validator(value) {
        return Object.values(Location).includes(value);
      },
    },
    treatmentIds: {
      type: Array, // Object of TratmentIds array or ProducIds array
    },
    productIds: {
      type: Array, // Object of TratmentIds array or ProducIds array
    },
    presentation: {
      type: String, // grid or carousel
    },
    itemQty: {
      type: Number, // Number of items wantend : min 4,  max 12
    },
    urlBase: {
      type: String,
    },
    cartItemsIds: {
      type: Array,
    },
    boxTitle: {
      type: String,
    },
    btnText: {
      type: String,
    },
    employeeId: {
      type: String,
    },
    overrideText: {
      type: String,
      default: null,
    },
  },
  computed: {
    items() {
      return this.recItems;
    },
  },
  watch: {
    userId: {
      handler() {
        this.getRecommendation();
      },
      deep: true,
    },
    productIds: {
      handler(oldValue, newValue) {
        this.handleIdChange(oldValue, newValue);
      },
      deep: true,
    },
    treatmentIds: {
      handler(oldValue, newValue) {
        this.handleIdChange(oldValue, newValue);
      },
      deep: true,
    },
    cartItemsIds: {
      handler(_oldValue, newValue) {
        if (newValue) {
          this.recItems.forEach((item) => {
            const splittedUrl = item.urlSafe?.split('/') || '';
            if (newValue && newValue.includes(splittedUrl[1])) {
              item.isAdded = true;
            } else {
              item.isAdded = false;
            }
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    stockAmount(id) {
      var stockAmount = 0;
      var item = this.recItems.filter((x) => x.id == id)[0];
      item.stockAmount.forEach((element) => {
        stockAmount += element.productStockAmount;
      });
      return stockAmount;
    },
    redirect(item) {
      this.logUserActivity(item, ActionType.Clicked);
      this.$emit('cardClick', item);
    },
    addToCard(item) {
      this.logUserActivity(item, ActionType.AddedToCart);
      this.$emit('buttonClick', item);
    },
    overrideBookingButton() {
      return this.overrideText && this.siteIds.length === 1;
    },
    priceHidden() {
      return this.$refs.recBox.classList.contains('price-hidden');
    },
    hideAddButton() {
      return this.$refs.recBox.classList.contains('add-hidden');
    },
    clickMoreBtn() {
      this.$emit('clickMoreBtn');
    },
    border() {
      return this.$refs.recBox.classList.contains('border');
    },
    handleIdChange(oldValue, newValue) {
      if (oldValue.length !== newValue.length) {
        this.getRecommendation();
      } else {
        for (let i = 0; i < newValue.length; i++) {
          if (oldValue[i] !== newValue[i]) {
            this.getRecommendation();
            break; // No need to continue the loop after finding a difference
          }
        }
      }
    },
    getRankingSourceById(id) {
      const item = this.recItems.find((item) => item.id === id);
      return item ? item.rankingSource : null;
    },
    getBase64ById(id) {
      const item = this.recItems.find((item) => item.id === id);
      return item ? item.idBase64 : null;
    },
    async getRecommendation() {
      this.isLoading = true;
      this.recItems = await service.getRecommendationItems({
        urlBase: this.urlBase,
        userId: this.userId,
        siteIds: this.siteIds,
        chainId: this.chainId,
        itemType: this.itemType,
        location: this.location,
        channel: this.channel,
        treatmentIds: this.treatmentIds,
        productIds: this.productIds,
        quantity: this.itemQty,
        cartItemsIds: this.cartItemsIds,
        employeeId: this.employeeId,
      });
      const hasItems = this.recItems.length > 0;
      this.$emit('itemsFetched', hasItems);
      this.isLoading = false;
    },
    async logUserActivity(item, action) {

      var id = this.getBase64ById(item.id);
      if (id != null && id != "") {
        this.logResp = await service.logUserActivity({
          urlBase: this.urlBase,
          userId: this.userId,
          isLoggedIn: this.userId ? true : false, // change
          chainId: this.chainId,
          siteIds: this.siteIds,
          location: this.location,
          channel: this.channel,
          location: this.location,
          // recommendationId: this.recommendationId
          rankingSource: this.getRankingSourceById(item.id),
          actionType: action,
          itemId: id,
          itemType: item.type,
        });
      }
    },
  },
  async mounted() {
    service = await RecSvc();
    this.getRecommendation();
  },
};
</script>
<style lang="scss">
.moreText {
  color: var(--v-primary-base);
  cursor: pointer;
  font-weight: 500;
}
.moreText:hover {
  text-decoration: underline;
}
.boxTitle {
  padding-bottom: 20px;
  font-size: 30px;
  text-align: left;
  font-weight: 300;
}
.titleCenter .boxTitle {
  text-align: center !important;
}
.titleBold .boxTitle {
  font-weight: bold;
}
.grid {
  .v-card {
    max-width: 420px !important;
    min-width: 143px !important;
  }
  .col-6 {
    padding: 8px !important;
  }
}

@media (max-width: 580px) {
  .slide-group .v-card {
    max-width: 164px !important;
  }
  .grid .col-6 {
    padding: 2px !important;
  }
  .tret.v-card {
    margin-left: 0px !important;
    margin-right: 2px !important;
    height: 260px !important;
  }
  .prod.v-card {
    margin-left: 0px !important;
    margin-right: 2px !important;
  }
  .boxTitle {
    text-align: center;
  }
}
@media screen and (max-width: 800px) and (min-width: 580px) {
  .slide-group .v-card {
    max-width: 200px !important;
  }
  .boxTitle {
    text-align: center;
  }
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .slide-group .v-card {
    max-width: 230px !important;
  }
}
@media screen and (min-width: 1300px) and (max-width: 1900px) {
  .slide-group .v-card {
    max-width: 270px !important;
  }
}
@media (min-width: 1900px) {
  .slide-group .v-card {
    max-width: 285px !important;
  }
  .grid.container,
  .slide-group.container {
    width: 1200px !important;
    margin: auto !important;
  }
}

.slide-group {
  .tret.v-card {
    max-height: 292px !important;
    margin-top: auto !important;
    margin-bottom: auto !important;
    margin-right: 17px !important;
    margin-left: 2px !important;
  }
  .prod.v-card {
    max-height: 450px !important;
    margin-top: auto !important;
    margin-bottom: auto !important;
    margin-right: 17px !important;
    margin-left: 2px !important;
  }
  .v-card {
    margin: 2px 4px !important;
  }
  .v-slide-group__content {
    padding: 4px 0px !important;
  }
  .v-btn.button {
    border: 2px solid var(--v-primary-base) !important;
  }
  .v-btn .v-icon {
    color: var(--v-primary-base) !important;
  }
  .v-slide-group__next--disabled,
  .v-slide-group__prev--disabled {
    display: none;
  }
}

h3 {
  padding-bottom: 20px !important;
}
</style>
